(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const media = window.matchMedia('(max-width: 989px)');
    const slot = document.querySelector('[data-bucks-mobile-slot]');
    let home;

    if (!slot) return;

    const place = () => {
      const box = document.querySelector('.buckscc-currency-box');

      if (!box) return;
      if (!home && !slot.contains(box)) home = { parent: box.parentNode, next: box.nextSibling };

      if (media.matches && box.parentNode !== slot) {
        slot.append(box);
      } else if (!media.matches && home?.parent?.isConnected && box.parentNode !== home.parent) {
        home.parent.insertBefore(box, home.next?.isConnected ? home.next : null);
      }
    };

    new MutationObserver(place).observe(document.body, { childList: true, subtree: true });
    media.addEventListener('change', place);
    place();
  })();
  } catch(e) { console.error(e); }
})();

})();
